import { usePersona } from "@opensea/navigation";
export function useExpandedSearchResultSize() {
  const {
    persona
  } = usePersona();
  const size = persona === "collector" ? "lg" : "md";
  return size;
}